module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable func-names */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-template */
/* eslint-disable no-lonely-if */
/* eslint-disable react/no-find-dom-node */
/* eslint-disable no-mixed-operators */

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing', spec);
};

var getTrackCSS = function getTracksCSS(spec) {
  checkSpecKeys(spec, ['left', 'slideCount', 'slidesToShow', 'slideWidth']);

  var trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;

  var style = {
    opacity: 1,
    WebkitTransform: 'translate3d(' + spec.left + 'px, 0px, 0px)',
    transform: 'translate3d(' + spec.left + 'px, 0px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: 'translateX(' + spec.left + 'px)'
  };

  if (trackWidth) {
    Object.assign(style, { width: trackWidth });
  }

  return style;
};

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);

  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
};

var getTrackLeft = function getTrackLeft(spec) {
  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'slideHeight']);

  var slideOffset = 0;

  if (spec.infinite) {
    if (spec.slideCount >= spec.slidesToShow) {
      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
    }
    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        if (spec.slideIndex > spec.slideCount) {
          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
        } else {
          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
        }
      }
    }
  } else {
    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
        slideOffset = slidesToOffset * spec.slideWidth;
      }
    }
  }

  return spec.slideIndex * spec.slideWidth * -1 + slideOffset;
};

module.exports = { getTrackCSS: getTrackCSS, getTrackAnimateCSS: getTrackAnimateCSS, getTrackLeft: getTrackLeft };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable react/no-find-dom-node */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-template */
/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable no-mixed-operators */

var React = __webpack_require__(0);

var _require = __webpack_require__(8),
    getTrackCSS = _require.getTrackCSS,
    getTrackLeft = _require.getTrackLeft,
    getTrackAnimateCSS = _require.getTrackAnimateCSS;

var helpers = {
  initialize: function initialize() {
    var props = this.props;

    this.slickWidth = this.getWidth(this.list.querySelector('.slick-slide'));
    var slideCount = React.Children.count(props.children);
    var listWidth = this.getWidth(this.list);
    var trackWidth = this.getWidth(this.track);
    var slidesToShow = Math.floor(listWidth / this.slickWidth) || 1;

    if (slidesToShow > props.slidesToShow) {
      slidesToShow = props.slidesToShow;
    }

    var slideWidth = this.getWidth(this.list) / slidesToShow;
    var slideHeight = this.getHeight(this.list.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * slidesToShow;

    var currentSlide = props.initialSlide;

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      currentSlide: currentSlide,
      slideHeight: slideHeight,
      listHeight: listHeight,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow
    }, function onSetState() {
      var targetLeft = getTrackLeft(Object.assign({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, this.props, this.state));

      // getCSS function needs previously set state
      var trackStyle = getTrackCSS(Object.assign({ left: targetLeft }, this.props, this.state));

      this.setState({ trackStyle: trackStyle });
      this.preload(this.state.currentSlide);

      this.autoPlay(); // once we're set up, trigger the initial autoplay.
    });
  },
  update: function update() {
    var props = this.props;
    // This method has mostly same code as initialize method.
    // Refactor it

    var slideCount = React.Children.count(props.children);
    var listWidth = this.getWidth(this.list);
    var trackWidth = this.getWidth(this.track);
    var slidesToShow = Math.floor(listWidth / this.slickWidth) || 1;

    if (slidesToShow > props.slidesToShow) {
      slidesToShow = props.slidesToShow;
    }

    var slideWidth = this.getWidth(this.list) / slidesToShow;
    var slideHeight = this.getHeight(this.list.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * slidesToShow;

    // pause slider if autoplay is set to false
    if (!props.autoplay) {
      this.pause();
    } else {
      this.autoPlay();
    }

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      slideHeight: slideHeight,
      listHeight: listHeight,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow
    }, function onSetState() {
      var targetLeft = getTrackLeft(Object.assign({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, this.props, this.state));
      // getCSS function needs previously set state
      var trackStyle = getTrackCSS(Object.assign({ left: targetLeft }, this.props, this.state));

      this.setState({ trackStyle: trackStyle });
      this.preload(this.state.currentSlide);
    });
  },
  getWidth: function getWidth(elem) {
    return elem ? elem.offsetWidth || 0 : null;
  },
  getHeight: function getHeight(elem) {
    return elem ? elem.offsetHeight || 0 : null;
  },
  canGoNext: function canGoNext(opts) {
    var canGo = true;
    if (!opts.infinite) {
      // check if all slides are shown in slider
      if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
        canGo = false;
      }
    }
    return canGo;
  },
  slideHandler: function slideHandler(targetSlide) {
    var _this = this;

    // Functionality of animateSlide and postSlide is merged into this function
    var currentSlide = void 0;
    var targetLeft = void 0;
    var callback = void 0;

    if (this.props.waitForAnimate && this.state.animating) {
      return;
    }

    if (targetSlide < 0) {
      if (this.props.infinite === false) {
        currentSlide = 0;
      } else if (this.state.slideCount % this.state.slidesToScroll !== 0) {
        currentSlide = this.state.slideCount - this.state.slideCount % this.state.slidesToScroll;
      } else {
        currentSlide = this.state.slideCount + targetSlide;
      }
    } else if (targetSlide >= this.state.slideCount) {
      if (this.props.infinite === false) {
        currentSlide = this.state.slideCount - this.state.slidesToShow;
      } else if (this.state.slideCount % this.state.slidesToScroll !== 0) {
        currentSlide = 0;
      } else {
        currentSlide = targetSlide - this.state.slideCount;
      }
    } else {
      currentSlide = targetSlide;
    }

    targetLeft = getTrackLeft(Object.assign({
      slideIndex: targetSlide,
      trackRef: this.track
    }, this.props, this.state));

    var currentLeft = getTrackLeft(Object.assign({
      slideIndex: currentSlide,
      trackRef: this.track
    }, this.props, this.state));

    if (this.props.infinite === false) {
      targetLeft = currentLeft;
    }

    if (this.props.beforeChange) {
      this.props.beforeChange(this.state.currentSlide, currentSlide);
    }
    this.preload(targetSlide);

    // Slide Transition happens here.
    // animated transition happens to target Slide and
    // non - animated transition happens to current Slide
    // If CSS transitions are false, directly go the current slide.

    if (this.props.useCSS === false) {
      this.setState({
        currentSlide: currentSlide,
        trackStyle: getTrackCSS(Object.assign({ left: currentLeft }, this.props, this.state))
      }, function onSetState() {
        if (this.props.afterChange) {
          this.props.afterChange(currentSlide);
        }
      });
    } else {
      var nextStateChanges = {
        animating: false,
        currentSlide: currentSlide,
        trackStyle: getTrackCSS(Object.assign({ left: currentLeft }, this.props, this.state)),
        swipeLeft: null
      };

      callback = function callback() {
        _this.setState(nextStateChanges);
        if (_this.props.afterChange) {
          _this.props.afterChange(currentSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: currentSlide,
        trackStyle: getTrackAnimateCSS(Object.assign({ left: targetLeft }, this.props, this.state))
      }, function onSetState() {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });
    }

    this.autoPlay();
  },
  preload: function preload(targetSlide) {
    if (this.props.lazyLoad) {
      var loaded = true;
      var slidesToLoad = [];
      for (var i = targetSlide; i < targetSlide + this.state.slidesToShow * this.props.pagesToPreload; i++) {
        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
        if (!loaded) {
          slidesToLoad.push(i);
        }
      }
      if (!loaded) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
        });
      }
    }
  },
  swipeDirection: function swipeDirection(touchObject) {
    return touchObject.startX > touchObject.curX ? 'left' : 'right';
  },
  play: function play() {
    var nextIndex = void 0;

    if (!this.state.mounted) {
      return false;
    }

    if (this.canGoNext(Object.assign({}, this.props, this.state))) {
      nextIndex = this.state.currentSlide + this.state.slidesToScroll;
    } else {
      return false;
    }

    this.slideHandler(nextIndex);
  },
  autoPlay: function autoPlay() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
    }
    if (this.props.autoplay) {
      this.setState({
        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
      });
    }
  },
  pause: function pause() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
      this.setState({
        autoPlayTimer: null
      });
    }
  }
};

module.exports = helpers;

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(32);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies
 */
var CarouselPaged = __webpack_require__(33);

/**
 * Expose Carousel
 */
module.exports = CarouselPaged;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var _require = __webpack_require__(34),
    PrevArrow = _require.PrevArrow,
    NextArrow = _require.NextArrow;

var Slider = __webpack_require__(35);
var InnerSlide = __webpack_require__(43);
var classNames = __webpack_require__(2);

var Carousel = function (_React$PureComponent) {
  _inherits(Carousel, _React$PureComponent);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.state = {
      autoplay: props.autoplay,
      loading: true,
      isServer: true
    };

    _this.onInteraction = _this.onInteraction.bind(_this);
    return _this;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line
      this.setState({ loading: false, isServer: false });
    }
  }, {
    key: 'onInteraction',
    value: function onInteraction() {
      this.setState({ autoplay: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Slide = _props.Slide,
          slides = _props.slides,
          sliderProps = _objectWithoutProperties(_props, ['Slide', 'slides']);

      sliderProps.autoplay = this.state.autoplay;
      sliderProps.onInteraction = this.onInteraction;

      this.slidesList = this.props.slides.map(function (_ref) {
        var Component = _ref.Component,
            slide = _objectWithoutProperties(_ref, ['Component']);

        var ThisSlide = Component || Slide;
        return _jsx(InnerSlide, {
          Component: ThisSlide,
          slide: slide
        }, slide.id);
      });

      /**
       * The slider component has a bug when SSR.
       * This workaround fixes the bug by disabling `infinite` for SSR.
       */
      sliderProps.infinite = sliderProps.infinite && !this.state.isServer;

      /**
       * 'autoplay' and 'arrows' need more than one page to work
       */
      var hasMoreThanOnePage = slides.length > sliderProps.slidesToShow;
      sliderProps.arrows = hasMoreThanOnePage && sliderProps.arrows;
      sliderProps.autoplay = hasMoreThanOnePage && sliderProps.autoplay;
      sliderProps.dots = hasMoreThanOnePage && sliderProps.dots;

      /**
       *  https://github.com/akiran/react-slick/issues/914
       */
      if (sliderProps.infinite) {
        sliderProps.lazyLoad = false;
      }

      if (sliderProps.pagesToPreload === 1) {
        sliderProps.pagesToPreload += !this.state.loading;
      }
      var className = classNames('carousel-container', { 'arrow-visible': this.props.arrowsVisible });
      return _jsx('div', {
        className: className,
        style: sliderProps.size
      }, void 0, React.createElement(
        Slider,
        sliderProps,
        this.slidesList
      ));
    }
  }]);

  return Carousel;
}(React.PureComponent);

Carousel.contextTypes = {
  lowEnd: PropTypes.bool
};

Carousel.propTypes = {
  arrows: PropTypes.bool,
  arrowsVisible: PropTypes.bool,
  autoplay: PropTypes.bool,
  beforeChange: PropTypes.func,
  dots: PropTypes.bool,
  pagesToPreload: PropTypes.number,
  slides: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })).isRequired,
  Slide: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(React.Component)]).isRequired,
  slidesToShow: PropTypes.number.isRequired,
  infinite: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  nextArrow: PropTypes.shape(NextArrow.propTypes),
  prevArrow: PropTypes.shape(PrevArrow.propTypes),
  lowEnd: PropTypes.bool
};

Carousel.defaultProps = {
  arrows: true,
  arrowsVisible: false,
  autoplay: false,
  beforeChange: null,
  dots: false,
  infinite: true,
  lazyLoad: true,
  nextArrow: _jsx(NextArrow, {}),
  pagesToPreload: 1,
  prevArrow: _jsx(PrevArrow, {}),
  lowEnd: false
};

module.exports = Carousel;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);

var PrevArrow = function PrevArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  var disabled = className.indexOf('slick-disabled') > 0 ? 'arrow-disabled' : '';
  return _jsx('button', {
    className: 'prev-button ' + disabled,
    onClick: onClick
  });
};

var NextArrow = function NextArrow(props) {
  var className = props.className,
      onClick = props.onClick;

  var disabled = className.indexOf('slick-disabled') > 0 ? 'arrow-disabled' : '';
  return _jsx('button', {
    className: 'next-button ' + disabled,
    onClick: onClick
  });
};

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

NextArrow.defaultProps = {
  className: '',
  onClick: null
};

PrevArrow.defaultProps = {
  className: '',
  onClick: null
};

module.exports = { PrevArrow: PrevArrow, NextArrow: NextArrow };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/sort-comp */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-else-return */

var React = __webpack_require__(0);
var InnerSlider = __webpack_require__(36);
var defaultProps = __webpack_require__(42);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
    return _this;
  }

  _createClass(Slider, [{
    key: 'innerSliderRefHandler',
    value: function innerSliderRefHandler(ref) {
      this.innerSlider = ref;
    }
  }, {
    key: 'slickPrev',
    value: function slickPrev() {
      this.innerSlider.slickPrev();
    }
  }, {
    key: 'slickNext',
    value: function slickNext() {
      this.innerSlider.slickNext();
    }
  }, {
    key: 'slickGoTo',
    value: function slickGoTo(slide) {
      this.innerSlider.slickGoTo(slide);
    }
  }, {
    key: 'render',
    value: function render() {
      var settings = Object.assign({}, defaultProps, this.props);
      var children = this.props.children;

      var sliderStyle = settings.size && settings.size.width ? { minWidth: settings.size.width } : null;
      if (!Array.isArray(children)) {
        children = [children];
      }

      // Children may contain false or null, so we should filter them
      children = children.filter(function (child) {
        return !!child;
      });

      return React.createElement(
        InnerSlider,
        _extends({ ref: this.innerSliderRefHandler }, settings, { style: sliderStyle }),
        children
      );
    }
  }]);

  return Slider;
}(React.Component);

module.exports = Slider;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prefer-es6-class */
/* eslint-disable react/sort-comp */
/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-template */
/* eslint-disable no-lonely-if */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/jsx-closing-bracket-location */

var React = __webpack_require__(0);
var classnames = __webpack_require__(2);
var eventHandlers = __webpack_require__(37);
var helpers = __webpack_require__(9);
var initialState = __webpack_require__(38);
var Track = __webpack_require__(39);
var Dots = __webpack_require__(40);

var _require = __webpack_require__(41),
    PrevArrow = _require.PrevArrow,
    NextArrow = _require.NextArrow;

var InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, (InnerSlider.__proto__ || Object.getPrototypeOf(InnerSlider)).call(this, props));

    _this.list = null;
    _this.track = null;
    _this.state = _this.getInitialState();
    _this.trackRefHandler = _this.trackRefHandler.bind(_this);
    _this.listRefHandler = _this.listRefHandler.bind(_this);
    _this.changeSlideBecauseInteraction = _this.changeSlideBecauseInteraction.bind(_this);
    _this.onWindowResized = _this.onWindowResized.bind(_this);

    // Helper mixins
    _this.initialize = helpers.initialize.bind(_this);
    _this.update = helpers.update.bind(_this);
    _this.getWidth = helpers.getWidth.bind(_this);
    _this.getHeight = helpers.getHeight.bind(_this);
    _this.canGoNext = helpers.canGoNext.bind(_this);
    _this.slideHandler = helpers.slideHandler.bind(_this);
    _this.preload = helpers.preload.bind(_this);
    _this.swipeDirection = helpers.swipeDirection.bind(_this);
    _this.play = helpers.play.bind(_this);
    _this.autoPlay = helpers.autoPlay.bind(_this);
    _this.pause = helpers.pause.bind(_this);

    // Event Handlers mixins
    _this.changeSlide = eventHandlers.changeSlide.bind(_this);
    _this.keyHandler = eventHandlers.keyHandler.bind(_this);
    _this.selectHandler = eventHandlers.selectHandler.bind(_this);
    _this.swipeStart = eventHandlers.swipeStart.bind(_this);
    _this.swipeMove = eventHandlers.swipeMove.bind(_this);
    _this.swipeEnd = eventHandlers.swipeEnd.bind(_this);
    _this.onInnerSliderEnter = eventHandlers.onInnerSliderEnter.bind(_this);
    _this.onInnerSliderOver = eventHandlers.onInnerSliderOver.bind(_this);
    _this.onInnerSliderLeave = eventHandlers.onInnerSliderLeave.bind(_this);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: 'listRefHandler',
    value: function listRefHandler(ref) {
      this.list = ref;
    }
  }, {
    key: 'trackRefHandler',
    value: function trackRefHandler(ref) {
      this.track = ref;
    }
  }, {
    key: 'getInitialState',
    value: function getInitialState() {
      return Object.assign({}, initialState, {
        currentSlide: this.props.initialSlide,
        slideCount: React.Children.count(this.props.children),
        slidesToShow: this.props.slidesToShow,
        slidesToScroll: this.props.slidesToScroll
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.init) {
        this.props.init();
      }
      this.setState({
        mounted: true
      });
      this.preload(this.state.currentSlide);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Hack for autoplay -- Inspect Later
      this.initialize();
      if (this.props.responsive) {
        window.addEventListener('resize', this.onWindowResized, false);
      }

      var msPointerSupported = window.navigator.msPointerEnabled;
      var touch = {
        start: msPointerSupported ? 'MSPointerDown' : 'touchstart',
        move: msPointerSupported ? 'MSPointerMove' : 'touchmove',
        end: msPointerSupported ? 'MSPointerUp' : 'touchend'
      };
      var touchPassiveListener = touch.start === 'touchstart' ? { passive: true, capture: false } : false;
      var movePassiveListener = touch.start === 'touchstart' ? { passive: false, capture: false } : false;
      this.list.addEventListener(touch.start, this.swipeStart, touchPassiveListener);
      this.list.addEventListener(touch.move, this.swipeMove, movePassiveListener);
      this.list.addEventListener(touch.end, this.swipeEnd, touchPassiveListener);

      // Agregar los remove en componentWillUnmount
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.animationEndCallback) {
        clearTimeout(this.animationEndCallback);
      }
      if (this.state.autoPlayTimer) {
        clearInterval(this.state.autoPlayTimer);
      }
      if (this.props.responsive) {
        window.removeEventListener('resize', this.onWindowResized, false);
      }
      var msPointerSupported = window.navigator.msPointerEnabled;
      var touch = {
        start: msPointerSupported ? 'MSPointerDown' : 'touchstart',
        move: msPointerSupported ? 'MSPointerMove' : 'touchmove',
        end: msPointerSupported ? 'MSPointerUp' : 'touchend'
      };
      var touchPassiveListener = touch.start === 'touchstart' ? { passive: true, capture: false } : false;
      var movePassiveListener = touch.start === 'touchstart' ? { passive: false, capture: false } : false;
      this.list.removeEventListener(touch.start, this.swipeStart, touchPassiveListener);
      this.list.removeEventListener(touch.move, this.swipeMove, movePassiveListener);
      this.list.removeEventListener(touch.end, this.swipeEnd, touchPassiveListener);
    }
  }, {
    key: 'onWindowResized',
    value: function onWindowResized() {
      this.update();
      // animating state should be cleared while resizing, otherwise autoplay stops working
      this.setState({
        animating: false
      });
      clearTimeout(this.animationEndCallback);
      delete this.animationEndCallback;
    }
  }, {
    key: 'slickPrev',
    value: function slickPrev() {
      this.changeSlide({ message: 'previous' });
    }
  }, {
    key: 'slickNext',
    value: function slickNext() {
      this.changeSlide({ message: 'next' });
    }
  }, {
    key: 'slickGoTo',
    value: function slickGoTo(slide) {
      slide = Number(slide);
      !isNaN(slide) && this.changeSlide({
        message: 'index',
        index: slide,
        currentSlide: this.state.currentSlide
      });
    }
  }, {
    key: 'changeSlideBecauseInteraction',
    value: function changeSlideBecauseInteraction() {
      this.changeSlide.apply(this, arguments);
      if (this.props.onInteraction) {
        setTimeout(this.props.onInteraction, this.props.speed);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = classnames('slick-initialized', 'slick-slider', this.props.className);

      var trackProps = {
        cssEase: this.props.cssEase,
        speed: this.props.speed,
        infinite: this.props.infinite,
        currentSlide: this.state.currentSlide,
        lazyLoad: this.props.lazyLoad,
        lazyLoadedList: this.state.lazyLoadedList,
        slideWidth: this.state.slideWidth,
        slidesToShow: this.state.slidesToShow,
        slidesToScroll: this.state.slidesToScroll,
        slideCount: this.state.slideCount,
        trackStyle: this.state.trackStyle,
        trackRefHandler: this.trackRefHandler
      };

      var dots = void 0;

      if (this.props.dots === true && this.state.slideCount >= this.state.slidesToShow) {
        var dotProps = {
          dotsClass: this.props.dotsClass,
          slideCount: this.state.slideCount,
          slidesToShow: this.state.slidesToShow,
          currentSlide: this.state.currentSlide,
          slidesToScroll: this.state.slidesToScroll,
          clickHandler: this.changeSlideBecauseInteraction,
          children: this.props.children,
          customPaging: this.props.customPaging
        };

        dots = React.createElement(Dots, _extends({}, dotProps, { key: 'dots' }));
      }

      var prevArrow = void 0;
      var nextArrow = void 0;

      var arrowProps = {
        infinite: this.props.infinite,
        currentSlide: this.state.currentSlide,
        slideCount: this.state.slideCount,
        slidesToShow: this.state.slidesToShow,
        prevArrow: this.props.prevArrow,
        nextArrow: this.props.nextArrow,
        clickHandler: this.changeSlideBecauseInteraction
      };

      if (this.props.arrows) {
        prevArrow = React.createElement(PrevArrow, _extends({}, arrowProps, { key: 'prev-arrow' }));
        nextArrow = React.createElement(NextArrow, _extends({}, arrowProps, { key: 'next-arrow' }));
      }

      // This is to not let you swipe if the number of slidePages is 1
      var hasMoreThanOnePage = arrowProps.slideCount > arrowProps.slidesToShow;

      return _jsx('div', {
        className: className,
        onMouseEnter: this.onInnerSliderEnter,
        onMouseLeave: this.onInnerSliderLeave,
        onMouseOver: this.onInnerSliderOver
      }, void 0, prevArrow, React.createElement(
        'div',
        {
          role: 'presentation',
          ref: this.listRefHandler,
          key: 'slick-list',
          className: 'slick-list'
          // onTouchStart={hasMoreThanOnePage ? this.swipeStart : null}
          // onTouchMove={this.state.dragging ? this.swipeMove : null}
          // onTouchEnd={this.swipeEnd}
          // onTouchCancel={this.state.dragging ? this.swipeEnd : null}
          , onKeyDown: this.keyHandler },
        React.createElement(
          Track,
          _extends({}, trackProps, { key: 'track' }),
          this.props.children
        )
      ), nextArrow, dots);
    }
  }]);

  return InnerSlider;
}(React.Component);

module.exports = InnerSlider;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable react/no-find-dom-node */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-template */
/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-restricted-properties */
var _require = __webpack_require__(8),
    getTrackCSS = _require.getTrackCSS,
    getTrackLeft = _require.getTrackLeft;

var EventHandlers = {
  // Event handler for previous and next
  changeSlide: function changeSlide(options) {
    var targetSlide = void 0;
    switch (options.message) {
      case 'next':
        targetSlide = this.state.currentSlide + this.state.slidesToShow;
        break;
      case 'previous':
        targetSlide = this.state.currentSlide - this.state.slidesToShow;
        break;
      case 'dots':
        targetSlide = options.index * options.slidesToScroll;
        if (targetSlide === this.state.currentSlide) {
          return;
        }
        break;
      case 'index':
        targetSlide = parseInt(options.index, 10);
        break;
      default:
        break;
    }
    if (!this.props.infinite) {
      if (targetSlide >= this.state.slideCount) {
        this.slideHandler(this.state.currentSlide);
        return;
      }
    }
    this.slideHandler(targetSlide);
  },


  // Accessiblity handler for previous and next
  keyHandler: function keyHandler(e) {
    // Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (e.keyCode === 37) {
        this.changeSlide({
          message: 'previous'
        });
      } else if (e.keyCode === 39) {
        this.changeSlide({
          message: 'next'
        });
      }
    }
  },

  // Focus on selecting a slide (click handler on track)
  selectHandler: function selectHandler(options) {
    this.changeSlide(options);
  },
  swipeStart: function swipeStart(e) {
    // eslint-disable-next-line
    if (typeof e.touches === 'undefined' || this.props.swipe === false) {
      return;
    }
    var posX = e.touches[0].pageX;
    var posY = e.touches[0].pageY;
    this.setState({
      dragging: false,
      isScrolling: false,
      touchObject: {
        startX: posX,
        curX: posX,
        startY: posY,
        curY: posY
      }
    });
  },
  swipeMove: function swipeMove(e) {
    if (this.state.isScrolling && !this.state.dragging || typeof e.touches === 'undefined') {
      return;
    }

    var _state = this.state,
        touchObject = _state.touchObject,
        currentSlide = _state.currentSlide;


    var curLeft = getTrackLeft(Object.assign({
      slideIndex: currentSlide,
      trackRef: this.track
    }, this.props, this.state));

    touchObject.curX = e.touches[0].pageX;
    touchObject.curY = e.touches[0].pageY;

    var diffX = touchObject.curX - touchObject.startX;
    var diffY = touchObject.curY - touchObject.startY;
    var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;

    var isScrolling = touchAngle > 45;
    if (isScrolling && !this.state.dragging) {
      this.setState({
        isScrolling: isScrolling
      });
      return;
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopPropagation();
    touchObject.swipeLength = Math.round(Math.abs(diffX, 2));
    var swipeLeft = curLeft + diffX;
    this.setState({
      touchObject: touchObject,
      swipeLeft: swipeLeft,
      dragging: true,
      isScrolling: false,
      trackStyle: getTrackCSS(Object.assign({ left: swipeLeft }, this.props, this.state))
    });
  },
  swipeEnd: function swipeEnd(e) {
    if (!this.state.dragging) {
      if (this.props.swipe && e.cancelable) {
        e.preventDefault();
      }
      return;
    }
    var touchObject = this.state.touchObject;
    /**
     * Proportionally reduce swipping distance before changing the page.
     */

    var minSwipe = this.state.listWidth / this.props.touchThreshold;

    // reset the state of touch related state variables.
    this.setState({
      dragging: false,
      isScrolling: false,
      swipeLeft: null,
      touchObject: {}
    });

    // Fix for #13
    if (!touchObject.swipeLength) {
      return;
    }

    if (touchObject.swipeLength > minSwipe) {
      var swipeDirection = this.swipeDirection(touchObject);
      this.changeSlide({ message: swipeDirection === 'left' ? 'next' : 'previous' });
    } else {
      this.changeSlide({ message: 'index', index: this.state.currentSlide });
    }
  },
  onInnerSliderEnter: function onInnerSliderEnter() {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderOver: function onInnerSliderOver() {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderLeave: function onInnerSliderLeave() {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.autoPlay();
    }
  }
};

module.exports = EventHandlers;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var initialState = {
  animating: false,
  dragging: false,
  isScrolling: false,
  autoPlayTimer: null,
  currentLeft: null,
  currentSlide: 0,
  listWidth: null,
  listHeight: null,
  slideCount: null,
  slideWidth: null,
  slideHeight: null,
  swipeLeft: null,
  touchObject: {
    startX: 0,
    curX: 0
  },
  lazyLoadedList: [],
  // added for react
  initialized: false,
  trackStyle: {},
  trackWidth: 0
};

module.exports = initialState;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-template */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-else-return */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-confusing-arrow */

var React = __webpack_require__(0);
var classnames = __webpack_require__(2);
var PropTypes = __webpack_require__(1);

var getSlideClasses = function getSlideClasses(spec) {
  var slickActive = spec.currentSlide <= spec.index && spec.index < spec.currentSlide + spec.slidesToShow;
  var slickCloned = spec.index < 0 || spec.index >= spec.slideCount;

  return classnames({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  return {
    width: spec.slideWidth
  };
};

var getKey = function getKey(child, fallbackKey) {
  return child.key === null || child.key === undefined ? fallbackKey : child.key;
};

var _ref = _jsx('div', {});

var renderSlides = function renderSlides(spec) {
  var key = void 0;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var count = React.Children.count(spec.children);

  React.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var mounted = !spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0;

    if (mounted) {
      child = elem;
    } else {
      child = _ref;
    }
    var childStyle = getSlideStyle(Object.assign({}, spec, { index: index }));
    var slickClasses = getSlideClasses(Object.assign({ index: index }, spec));
    var cssClasses = void 0;

    if (child.props.className) {
      cssClasses = classnames(slickClasses, child.props.className);
    } else {
      cssClasses = slickClasses;
    }

    var onClick = function onClick(e) {
      child.props && child.props.onClick && child.props.onClick(e);
    };

    slides.push(React.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: cssClasses,
      tabIndex: '-1',
      mounted: mounted,
      style: Object.assign({ outline: 'none' }, child.props.style || {}, childStyle),
      onClick: onClick
    }));

    if (spec.infinite) {
      var infiniteCount = spec.slidesToShow;

      if (index >= count - infiniteCount) {
        key = -(count - index);
        preCloneSlides.push(React.cloneElement(child, {
          key: 'precloned' + getKey(child, key),
          'data-index': key,
          className: cssClasses,
          mounted: mounted,
          style: Object.assign({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }

      if (index < infiniteCount) {
        key = count + index;
        postCloneSlides.push(React.cloneElement(child, {
          key: 'postcloned' + getKey(child, key),
          'data-index': key,
          className: cssClasses,
          mounted: mounted,
          style: Object.assign({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }
    }
  });

  return preCloneSlides.concat(slides, postCloneSlides);
};

var Track = function (_React$Component) {
  _inherits(Track, _React$Component);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));
  }

  _createClass(Track, [{
    key: 'render',
    value: function render() {
      var slides = renderSlides.call(this, this.props);
      return React.createElement(
        'div',
        { className: 'slick-track', style: this.props.trackStyle, ref: this.props.trackRefHandler },
        slides
      );
    }
  }]);

  return Track;
}(React.Component);

Track.propTypes = {
  trackStyle: PropTypes.object
};

Track.defaultProps = {
  trackStyle: null
};

module.exports = Track;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-bind */
/* eslint-disable prefer-spread */
/* eslint-disable react/no-array-index-key */

var React = __webpack_require__(0);
var classnames = __webpack_require__(2);
var PropTypes = __webpack_require__(1);

var getDotCount = function onGetDotCount(spec) {
  var dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  return dots;
};

var Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, (Dots.__proto__ || Object.getPrototypeOf(Dots)).apply(this, arguments));
  }

  _createClass(Dots, [{
    key: 'clickHandler',
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dotCount = getDotCount({
        slideCount: this.props.slideCount,
        slidesToScroll: this.props.slidesToScroll
      });

      // Apply join & split to Array to pre-fill it for IE8
      //
      // Credit: http://stackoverflow.com/a/13735425/1849458
      var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
        var leftBound = i * _this2.props.slidesToScroll;
        var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
        var className = classnames({
          'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
        });

        var dotOptions = {
          message: 'dots',
          index: i,
          slidesToScroll: _this2.props.slidesToScroll,
          currentSlide: _this2.props.currentSlide
        };

        var onClick = _this2.clickHandler.bind(_this2, dotOptions);

        return _jsx('li', {
          className: className
        }, i, React.cloneElement(_this2.props.customPaging(i), { onClick: onClick }));
      });

      return _jsx('ul', {
        className: this.props.dotsClass,
        style: { display: 'block' }
      }, void 0, dots);
    }
  }]);

  return Dots;
}(React.PureComponent);

Dots.propTypes = {
  clickHandler: PropTypes.func,
  customPaging: PropTypes.func,
  currentSlide: PropTypes.number,
  slideCount: PropTypes.number,
  slidesToScroll: PropTypes.number,
  dotsClass: PropTypes.string
};
Dots.defaultProps = {
  clickHandler: null,
  customPaging: null,
  currentSlide: 0,
  slideCount: 0,
  slidesToScroll: 0,
  dotsClass: ''
};

module.exports = Dots;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-multi-comp */

var React = __webpack_require__(0);
var classnames = __webpack_require__(2);
var Helpers = __webpack_require__(9);
var PropTypes = __webpack_require__(1);

var PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, (PrevArrow.__proto__ || Object.getPrototypeOf(PrevArrow)).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: 'clickHandler',
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
      var prevHandler = this.clickHandler.bind(this, { message: 'previous' });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses['slick-disabled'] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: '0',
        'data-role': 'none',
        className: classnames(prevClasses),
        style: { display: 'block' },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow = void 0;

      if (this.props.prevArrow) {
        prevArrow = React.cloneElement(this.props.prevArrow, Object.assign({}, prevArrowProps, customProps));
      } else {
        prevArrow = React.createElement(
          'button',
          _extends({ key: '0', type: 'button' }, prevArrowProps),
          ' Previous'
        );
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(React.PureComponent);

var NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, (NextArrow.__proto__ || Object.getPrototypeOf(NextArrow)).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: 'clickHandler',
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }
      this.props.clickHandler(options, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var nextClasses = { 'slick-arrow': true, 'slick-next': true };
      var nextHandler = this.clickHandler.bind(this, { message: 'next' });

      if (!Helpers.canGoNext(this.props)) {
        nextClasses['slick-disabled'] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: '1',
        'data-role': 'none',
        className: classnames(nextClasses),
        style: { display: 'block' },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow = void 0;

      if (this.props.nextArrow) {
        nextArrow = React.cloneElement(this.props.nextArrow, Object.assign({}, nextArrowProps, customProps));
      } else {
        nextArrow = React.createElement(
          'button',
          _extends({ key: '1', type: 'button' }, nextArrowProps),
          ' Next'
        );
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(React.PureComponent);

NextArrow.propTypes = {
  clickHandler: PropTypes.func,
  nextHandler: PropTypes.func,
  currentSlide: PropTypes.number,
  slideCount: PropTypes.number,
  nextArrow: PropTypes.object
};

NextArrow.defaultProps = {
  clickHandler: null,
  nextHandler: null,
  currentSlide: 0,
  slideCount: 0,
  nextArrow: null
};

PrevArrow.propTypes = {
  clickHandler: PropTypes.func,
  infinite: PropTypes.bool,
  currentSlide: PropTypes.number,
  slideCount: PropTypes.number,
  slidesToShow: PropTypes.number,
  prevArrow: PropTypes.object
};
PrevArrow.defaultProps = {
  clickHandler: null,
  infinite: false,
  currentSlide: 0,
  slideCount: 0,
  slidesToShow: 0,
  prevArrow: null
};

module.exports = { PrevArrow: PrevArrow, NextArrow: NextArrow };

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var React = __webpack_require__(0);

var defaultProps = {
  className: '',
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  cssEase: 'ease',
  customPaging: function customPaging(i) {
    return _jsx('button', {}, void 0, i + 1);
  },

  dots: false,
  dotsClass: 'slick-dots',
  infinite: false,
  initialSlide: 0,
  lazyLoad: true,
  pauseOnHover: true,
  responsive: true,
  slide: 'div',
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 300,
  swipe: true,
  touchThreshold: 5,
  useCSS: true,
  waitForAnimate: true,
  afterChange: null,
  beforeChange: null,
  init: null,
  // nextArrow, prevArrow are react componets
  nextArrow: null,
  prevArrow: null,
  pagesToPreload: 1
};

module.exports = defaultProps;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/forbid-prop-types */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var InnerSlide = function InnerSlide(props) {
  var Component = props.Component,
      slide = props.slide,
      mounted = props.mounted,
      rest = _objectWithoutProperties(props, ['Component', 'slide', 'mounted']);

  return React.createElement(
    'div',
    _extends({ key: slide.id }, rest),
    React.createElement(Component, _extends({ key: slide.id }, slide, { mounted: mounted }))
  );
};

InnerSlide.propTypes = {
  Component: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(React.Component)]).isRequired,
  slide: PropTypes.object.isRequired,
  mounted: PropTypes.any
};

InnerSlide.defaultProps = {
  mounted: false
};

module.exports = InnerSlide;

/***/ })
/******/ ]);